import type { Ref } from '@nuxtjs/composition-api';
import { ref, readonly, useContext } from '@nuxtjs/composition-api';
import { Logger } from '~/helpers/logger';
import { UseProductsBlocksInterface, UseProductsBlocksError } from '~/modules/catalog/product/composables/useProductsBlocks/useProductsBlocks';
import { productsBlocksCommand } from '~/modules/catalog/product/composables/useProductsBlocks/commands/productsBlocksCommand';

export function useProductsBlocks(): UseProductsBlocksInterface {
  const context = useContext();
  const loading = ref(false);
  const error: Ref<UseProductsBlocksError> = ref({
    search: null,
  });

  const search = async (identifiers: string[]) => {
    let result = null;

    try {
      loading.value = true;

      Logger.debug('[Magento] Load products blocks based on ', { identifiers });

      result = productsBlocksCommand.execute(context, identifiers);

      Logger.debug('[Result] Product blocks:', result);

      error.value.search = null;
    } catch (err) {
      error.value.search = err;
      Logger.error('useProductsBlocks/search', err);
    } finally {
      loading.value = false;
    }

    return result;
  }

  return {
    search,
    loading: readonly(loading),
    error: readonly(error),
  }
}
